import styles from "./NeoTabEZ.module.css";
import { useState } from 'react';
import { useInView } from 'react-intersection-observer';

export default function NeoTabEZ() {
    const mainImage = require("./assets/main-img.png");
    const mainImgLeft = require("./assets/main-img-left.png");
    const mainImgRight = require("./assets/main-img-right.png");
    const iconReport = require("./assets/icon-report.png");
    const iconArrowDown = require("./assets/icon-arrow-down.png");
    const iconGov = require("./assets/icon-gov.png");
    const iconPaper = require("./assets/icon-paper.png");
    const ezPhone1 = require("./assets/ez-phone-1.png");
    const ezPhone2 = require("./assets/ez-phone-2.png");
    const ezPhone3 = require("./assets/ez-phone-3.png");
    const ezPhone4 = require("./assets/ez-phone-4.png");
    const ezWebToon1 = require("./assets/ez-webtoon-1.png");
    const ezWebToon2 = require("./assets/ez-webtoon-2.png");
    const ezWebToon3 = require("./assets/ez-webtoon-3.png");
    const ezWebToon4 = require("./assets/ez-webtoon-4.png");
    const ezBottomContentItem = require("./assets/ez-bottom-content-item.png");

    const [activeEzTab, setActiveEzTab] = useState('main');

    const mainContentStyle = {
        background: activeEzTab === 'bonus'
            ? '#FFD789'
            : 'linear-gradient(102.65deg, #6BA1FF 30%, #4287FF 100%)',
    };

    const observerOptions = {
        triggerOnce: true,
        threshold: 0.1,
    };

    const { ref: titleSubtitleRef, inView: titleSubtitleInView } = useInView(observerOptions);
    const { ref: mainImageCenterRef, inView: mainImageCenterInView } = useInView({ ...observerOptions, threshold: 0.2 });
    const { ref: mainImgLeftRef, inView: mainImgLeftInView } = useInView({ ...observerOptions, threshold: 0.3 });
    const { ref: mainImgRightRef, inView: mainImgRightInView } = useInView({ ...observerOptions, threshold: 0.3 });

    return (
        <div className={styles.container}>
            <div ref={titleSubtitleRef} className={`${styles.titleSubtitleWrapper} ${titleSubtitleInView ? styles.animateSlideUp : ''}`}>
                <div className={styles.title}>
                    <p>고객 동의, 이젠 선택이 아닌 <span>필수!</span></p>
                    <p>네오탭 이지(EZ)로 간편하게 해결하세요</p>
                </div>

                <div className={styles.subtitle}>
                    <p>고객 동의 없는 무단 문자 발송? 과태료 폭탄!</p>
                    <p>종이 없이, 네오탭 이지로 스마트하게 관리하세요.</p>
                </div>
            </div>

            <div className={styles.mainImage}>
                <img
                    ref={mainImgLeftRef}
                    src={mainImgLeft}
                    alt="배경 왼쪽 봉투"
                    className={`${styles.mainImageLeft} ${mainImgLeftInView ? styles.animateSlideRight : ''}`}
                    style={{ transitionDelay: '1s' }}
                />
                <img
                    ref={mainImageCenterRef}
                    src={mainImage}
                    alt="배경 휴대폰"
                    className={`${styles.mainImageCenter} ${mainImageCenterInView ? styles.animateSlideUp : ''}`}
                    style={{ transitionDelay: '0.2s' }}
                />
                <img
                    ref={mainImgRightRef}
                    src={mainImgRight}
                    alt="배경 오른쪽 봉투"
                    className={`${styles.mainImageRight} ${mainImgRightInView ? styles.animateSlideLeft : ''}`}
                    style={{ transitionDelay: '1.2s' }}
                />
            </div>

            <div className={styles.reportCase}>
                <p>고객 신고 사례</p>
                <div className={styles.reportCaseBox}>
                    <p>
                        경기도 한 정비업소는 고객동의를 받지 않고 고객에게 예방문자(엔진오일교환일 도래 관련) 전송
                    </p>
                </div>

                <div className={styles.reportCaseList}>
                    <ul>
                        <li>
                            <div className={styles.itemIconContainer}>
                                <img src={iconReport} alt="신고 아이콘" />
                            </div>
                            <div className={styles.itemTextContainer}>
                                <h4>고객이 행정관청에 신고</h4>
                                <p>서비스가 아닌 개인정보 도용 의심으로 신고</p>
                            </div>
                        </li>
                        <li className={styles.itemConnector}>
                            <img src={iconArrowDown} alt="아래로" />
                        </li>
                        <li>
                            <div className={styles.itemIconContainer}>
                                <img src={iconGov} alt="행정관청 아이콘" />
                            </div>
                            <div className={styles.itemTextContainer}>
                                <h4>행정관청에서 계도</h4>
                                <p>행정 계도 및 위반 지속 시 규정에 따른 처벌 경고</p>
                            </div>
                        </li>
                        <li className={styles.itemConnector}>
                            <img src={iconArrowDown} alt="아래로" />
                        </li>
                        <li>
                            <div className={styles.itemIconContainer}>
                                <img src={iconPaper} alt="종이 동의서 아이콘" />
                            </div>
                            <div className={styles.itemTextContainer}>
                                <h4>종이 동의서 받음</h4>
                                <p>동의서를 받은 후 관리와 보관 등 어려움을 겪음</p>
                            </div>
                        </li>
                    </ul>
                </div>

                <div className={styles.reportCaseLine}></div>

                <div className={styles.reportCaseBottom}>
                    <h4>문제점</h4>
                    <p>개인정보 동의를 종이로 받는 게 번거롭고, 보관이나 이슈 터졌을 때 찾는 것도 문제라는 걸 이번에 알게 됨</p>
                </div>

                <div className={styles.aboutNeoEzContainerTitle}>
                    <h4>네오탭 이지(EZ)는?</h4>
                    <p>네오탭 기능 중 개인정보동의를 간편하게 받을 수 있도록 도와주는 앱 도우미입니다.</p>
                </div>

                <div className={styles.aboutEzContainer}>
                    <div className={styles.aboutEzContent} style={mainContentStyle}>
                        <div className={styles.innerContentWrapper}>
                            <div className={styles.ezPhoneImages}>
                                {activeEzTab === "main" ? (
                                    <>
                                        <img key={`main-left-${activeEzTab}`} src={ezPhone1} className={`${styles.ezPhoneLeft} ${styles.ezPhoneBase}`} alt="이지 휴대폰 주요 기능 좌측 이미지" />
                                        <img key={`main-right-${activeEzTab}`} src={ezPhone2} className={`${styles.ezPhoneRight} ${styles.ezPhoneBase}`} alt="이지 휴대폰 주요 기능 우측 이미지" />
                                    </>
                                ) : (
                                    <>
                                        <img key={`bonus-left-${activeEzTab}`} src={ezPhone3} className={`${styles.ezPhoneLeft} ${styles.ezPhoneBase}`} alt="이지 휴대폰 보너스 기능 좌측 이미지" />
                                        <img key={`bonus-right-${activeEzTab}`} src={ezPhone4} className={`${styles.ezPhoneRight} ${styles.ezPhoneBase}`} alt="이지 휴대폰 보너스 기능 우측 이미지" />
                                    </>
                                )}
                            </div>
                            <div className={styles.ezTextContent}>
                                {activeEzTab === 'main' && (
                                    <div className={styles.ezTabContentItemVisible}>
                                        <h3>주요 기능</h3>
                                        <p>개인정보 동의를</p>
                                        <p>종이 없이, 모바일로 바로 간편하게!</p>
                                    </div>
                                )}
                                {activeEzTab === 'bonus' && (
                                    <div className={styles.ezTabContentItemBonusVisible}>
                                        <h3>보너스 기능</h3>
                                        <p>개인정보동의 뿐만 아니라 추가로 보너스 기능이 있습니다.</p>
                                        <p>모바일 규격정보 조회 : 차량 제원도 더 정확하게! (10회/월)</p>
                                        <p>모바일 수리이력 조회 : 차량번호만 말하면 척척! (10회/월)</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={styles.ezTabs}>
                        <button
                            className={`${styles.ezTabButton} ${activeEzTab === 'main' ? styles.active : ''}`}
                            onClick={() => setActiveEzTab('main')}
                        >
                            주요 기능
                        </button>
                        <button
                            className={`${styles.ezTabButton} ${styles.bonusTab} ${activeEzTab === 'bonus' ? styles.active : ''}`}
                            onClick={() => setActiveEzTab('bonus')}
                        >
                            보너스 기능
                        </button>
                    </div>
                </div>

                <div className={styles.aboutEzContainerMobile}>
                    <div className={styles.aboutEzContainerMobileItemFeature}>
                        <h3>주요 기능</h3>
                        <p>개인정보 동의를</p>
                        <p>종이 없이, 모바일로 바로 간편하게!</p>
                    </div>

                    <div className={styles.aboutEzContainerMobileItemBonus}>
                        <h3>보너스 기능</h3>
                        <p>개인정보동의 뿐만 아니라 추가로 보너스 기능이 있습니다.</p>
                        <p style={{ fontWeight: 'bold', paddingTop: '5px' }}>모바일 규격정보 조회 : </p>
                        <p>차량 제원도 더 정확하게! (10회/월)</p>
                        <p style={{ fontWeight: 'bold' }}>모바일 수리이력 조회 :</p>
                        <p>차량번호만 말하면 척척! (10회/월)</p>
                    </div>
                </div>

                <div className={styles.ezWebToonContainer}>
                    <h3>쉽게 알아보는 네오탭 이지(EZ)</h3>

                    <div className={styles.ezWebToonContent}>
                        <div className={styles.webtoonPanel}>
                            <img src={ezWebToon1} alt="웹툰 이미지" />
                        </div>
                        <div className={styles.webtoonPanel}>
                            <img src={ezWebToon2} alt="웹툰 이미지" />
                        </div>
                        <div className={styles.webtoonPanel}>
                            <img src={ezWebToon3} alt="웹툰 이미지" />
                        </div>
                        <div className={styles.webtoonPanel}>
                            <img src={ezWebToon4} alt="웹툰 이미지" />
                        </div>
                    </div>
                </div>
            </div>

            <div className={styles.ezBottomContainer}>
                <div className={styles.ezBottomContent}>
                    <div className={styles.ezBottomContentItem}>
                        <img src={ezBottomContentItem} alt="네오탭 풀버전 이미지" />
                    </div>
                    <div className={styles.ezBottomContentItemText}>
                        <h3>네오탭 풀 버전</h3>
                        <p>네오탭 이지(EZ)로 부족하다면</p>
                        <p>네오탭 풀 버전의 다양한 기능을 사용하시면 좋습니다.</p>

                        <div className={styles.ezBottomContentBox}>
                            <h3>네오탭 풀 버전이란?</h3>
                            <p>집이나, 현장 출동 시나 어디서나 수리이력, 규격정보 조회 가능</p>
                            <p>주요기능</p>
                            <p>음성입력 및 조회 / 매출관리 및 결산 기능 / 차량번호·차대번호 인식 기능</p>
                            <p>/ 국토부 전송 기능 / 부품바코드 인식 기능 / 예약 및 해피콜</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
